import { api } from 'boot/axios'
import type {
  AnonymousLeadApiResponse,
  AnonymousLeadFormData
} from 'src/models/anonymous-lead'

export default {
  /**
   * Get form options for anonymous lead submission (ApiForm compatible)
   */
  getFormOptions(): Promise<{ data: { actions: { POST: any }, throttle_info?: any } }> {
    return api.options('anonymous-leads/')
  },

  /**
   * Create an anonymous lead submission
   */
  createAnonymousLead(data: AnonymousLeadFormData): Promise<{ data: AnonymousLeadApiResponse }> {
    return api.post('anonymous-leads/', data, {
      // Custom flag to indicate this endpoint handles its own throttling
      metadata: { handleOwnThrottling: true }
    })
  }
}
